(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (function () {
    const content = document.querySelector('#ArticleBody');
    const tocs = document.querySelectorAll('.js-table-of-contents');

    if (!content || !tocs.length) return;

    const headings = content.querySelectorAll('h2, h3, h4, h5, h6');

    if (!headings.length) {
      tocs.forEach((toc) => {
        toc.innerHTML = '<div class="fs-small">No headings found.</div>';
      });
      return;
    }

    const slugify = (str) => {
      return (str || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/<\/?[^>]+(>|$)/g, '')
        .replace(/&[^\s;]+;/g, '')
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    };

    const usedIds = new Set();

    document.querySelectorAll('[id]').forEach((el) => {
      if (el.id) usedIds.add(el.id);
    });

    const ensureId = (el) => {
      if (el.id) {
        usedIds.add(el.id);
        return el.id;
      }

      let base = slugify(el.textContent);
      if (!base) base = 'section';

      let uniqueId = base;
      let i = 2;

      while (usedIds.has(uniqueId) || document.getElementById(uniqueId)) {
        uniqueId = `${base}-${i++}`;
      }

      usedIds.add(uniqueId);
      el.id = uniqueId;
      return uniqueId;
    };

    const headingItems = Array.from(headings).map((heading) => {
      return {
        el: heading,
        id: ensureId(heading),
        text: heading.textContent.trim(),
        level: heading.tagName.toLowerCase(),
      };
    });

    const buildTocList = () => {
      const ul = document.createElement('ul');

      headingItems.forEach((item) => {
        const li = document.createElement('li');
        const a = document.createElement('a');

        a.href = `#${item.id}`;
        a.textContent = item.text;
        a.classList.add(`toc-${item.level}`);

        li.appendChild(a);
        ul.appendChild(li);
      });

      return ul;
    };

    tocs.forEach((toc) => {
      toc.innerHTML = '';
      toc.appendChild(buildTocList());
    });

    const HEADER_OFFSET = 180;

    tocs.forEach((toc) => {
      toc.addEventListener('click', (e) => {
        const link = e.target.closest('a[href^="#"]');
        if (!link) return;

        const targetId = link.getAttribute('href').slice(1);
        const targetEl = document.getElementById(targetId);

        if (!targetEl) return;

        e.preventDefault();

        const y = targetEl.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;

        window.scrollTo({
          top: y,
          behavior: 'smooth',
        });

        history.replaceState(null, '', `#${targetId}`);
      });
    });

    const getAllTocLinks = () => document.querySelectorAll('.js-table-of-contents a[href^="#"]');

    const setActive = (id) => {
      getAllTocLinks().forEach((link) => {
        link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
      });
    };

    let currentActiveId = headingItems[0]?.id || '';

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            currentActiveId = entry.target.id;
          }
        });

        if (currentActiveId) {
          setActive(currentActiveId);
        }
      },
      {
        root: null,
        rootMargin: `-${HEADER_OFFSET}px 0px -65% 0px`,
        threshold: 0.15,
      }
    );

    headingItems.forEach((item) => observer.observe(item.el));

    if (window.location.hash) {
      const initialId = window.location.hash.replace('#', '');
      if (document.getElementById(initialId)) {
        setActive(initialId);
      }
    } else if (headingItems.length) {
      setActive(headingItems[0].id);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
